(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  if (!customElements.get('vergelijkbare-items')) {
    class VergelijkbareItems extends HTMLElement {
      connectedCallback() {
        if (this._started) return;
        this._started = true;
        const io = new IntersectionObserver((entries, obs) => {
          if (!entries[0].isIntersecting) return;
          obs.disconnect();
          this.load();
        }, { rootMargin: '0px 0px 400px 0px' });
        // hidden elements are never "intersecting", so observe the parent
        io.observe(this.parentElement || this);
      }

      handleOf(card) {
        const a = card.querySelector('a[href*="/products/"]');
        if (!a) return null;
        const m = new URL(a.getAttribute('href'), location.origin).pathname.match(/\/products\/([^\/?#]+)/);
        return m ? m[1] : null;
      }

      async load() {
        const limit = parseInt(this.dataset.limit, 10) || 10;
        const seen = new Set([this.dataset.self]);
        const cards = [];
        const add = (card) => {
          if (cards.length >= limit) return;
          const h = this.handleOf(card);
          if (!h || seen.has(h)) return;
          seen.add(h);
          cards.push(document.importNode(card, true));
        };

        // 1. Handmatig gekozen producten eerst
        const manual = this.querySelector('template[data-vi-manual]');
        if (manual) Array.from(manual.content.children).filter((el) => el.classList.contains('card--product')).forEach(add);

        // 2. Zelfde type + print, 3. zelfde type
        for (const url of [this.dataset.urlPrint, this.dataset.urlType]) {
          if (!url || cards.length >= limit) continue;
          try {
            const res = await fetch(url);
            if (!res.ok) continue;
            const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
            doc.querySelectorAll('[data-vi-auto] > .card--product').forEach(add);
          } catch (e) {
            console.error('Vergelijkbare items:', e);
          }
        }

        if (!cards.length) return;

        const shell = this.querySelector('template[data-vi-shell]').content.cloneNode(true);
        const track = shell.querySelector('.gridy-track');
        cards.forEach((c) => track.appendChild(c));

        const arrows = shell.querySelector('.gridy-arrows');
        if (arrows) {
          const n = cards.length;
          if (n <= parseInt(this.dataset.iprDesktop, 10)) arrows.classList.add('md-hide');
          if (n <= parseInt(this.dataset.iprTablet, 10)) arrows.classList.add('sm-to-md-hide');
          if (n <= parseInt(this.dataset.iprMobile, 10)) arrows.classList.add('sm-down-hide');
        }

        this.appendChild(shell);
        this.hidden = false;
      }
    }
    customElements.define('vergelijkbare-items', VergelijkbareItems);
  }

  // Oorspronkelijk element blijven aanbieden voor andere plekken die het nog gebruiken
  if (!customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }
              this.classList.add('products-loaded');
            })
            .catch(e => console.error(e));
        };
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
      }
    }
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
